const commonLocaleMessages = {};

const loadLocaleMessages = () => {
  const locales = import.meta.glob("./*.json", { eager: true });
  const keys = Object.keys(locales);
  //   console.log("keys", keys);
  // 执行批量替换操作
  for (let key of keys) {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      commonLocaleMessages[locale] = locales[key];
    }
  }
  return commonLocaleMessages;
};

loadLocaleMessages();

export default commonLocaleMessages;
